// action - state management
import { PROFILE_IMAGE, TREEVIEW, SELECTED_TREE_ITEM } from './actions';
import defaultImages from 'assets/images/users/default.png';

// initial state
const initialCommonState = {
  treeView: 'sections.0',
  selectedTreeItem: 'sections.0',
  profileImage: null
};

// ==============================|| AUTH REDUCER ||============================== //

const common = (state = initialCommonState, action) => {
  switch (action.type) {
    case PROFILE_IMAGE: {
      const { profileImage } = action.payload;
      const urlImg = profileImage ? URL.createObjectURL(profileImage) : defaultImages;
      return {
        ...state,
        profileImage: urlImg
      };
    }
    case TREEVIEW: {
      const { treeView } = action.payload;
      return {
        ...state,
        treeView
      };
    }
    case SELECTED_TREE_ITEM: {
      const { selectedTreeItem } = action.payload;
      return {
        ...state,
        selectedTreeItem
      };
    }
    default: {
      return { ...state };
    }
  }
};
export { initialCommonState };
export default common;
